import type { Feature, FeatureCollection, Geometry } from 'geojson';

export interface IndoorActiveMap {
    version: number;
    fileName: string;
    sizeBytes: number;
    uploadedAt: string;
}

export interface IndoorFloor {
    floorId: string;
    floorName: string;
    floorNumber: number;
    venueId: string;
    venueName: string;
    companyId: string;
    activeMap: IndoorActiveMap | null;
}

export interface IndoorMapVersion {
    id: string;
    floorId: string;
    version: number;
    fileName: string;
    sizeBytes: number;
    levelName: string;
    featureCounts: Record<string, number>;
    uploadedBy: string;
    createdAt: string;
    isActive: boolean;
    hasNetwork: boolean;
    network: IndoorNetworkBuild | null;
}

export interface IndoorNetworkWarning {
    code: string;
    subject: string | null;
    message: string;
}

export interface IndoorNetworkBuild {
    nodeCount: number;
    edgeCount: number;
    laneCount: number;
    zoneCount: number;
    beaconCount: number;
    droppedNodeCount: number;
    warnings: IndoorNetworkWarning[];
}

export interface IndoorDateRange {
    startDate: string | null;
    endDate: string | null;
}

export enum IndoorPeriod {
    LastDay = 'lastDay',
    Last7Days = 'last7Days',
    Custom = 'custom'
}

export type LayerGroupKey =
    | 'zones'
    | 'roads'
    | 'beacons'
    | 'racks'
    | 'wallsColumns'
    | 'equipment'
    | 'units'
    | 'labels'
    | 'detail';

export type LayerVisibility = Record<LayerGroupKey, boolean>;

export interface LocalizedName {
    tr?: string;
    en?: string;
}

export interface IndoorFeatureProperties {
    feature_type?: string;
    category?: string;
    code?: string;
    name?: LocalizedName | string | null;
    area_m2?: number;
    height_m?: number;
    zone_code?: string;
    serial?: string | null;
    fw_view?: { default_bearing?: number };
    display_point?: { type: 'Point'; coordinates: [number, number] };
    [key: string]: unknown;
}

export type IndoorFeature = Feature<Geometry, IndoorFeatureProperties>;
export type IndoorFeatureCollection = FeatureCollection<Geometry, IndoorFeatureProperties>;

export interface IndoorForklift {
    forkliftId: string;
    name: string;
}

export interface IndoorMapData {
    floorId: string;
    version: number;
    geoJson: IndoorFeatureCollection;
}

export interface MapHighlight {
    floorId: string;
    codes: string[];
    crashEventIds: string[];
    focus: boolean;
    requestId: number;
}
